import React, { useEffect, useState, useRef } from 'react';

import { Company } from '../../classess/company/company';
import { StatementAccountByCompany } from '../../classess/sales/statementAccountByCompany';
import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, sendMessageTwo, setSeparatorsNumbers, settings, styles, LoadingSection, handleResponseMessageAsync
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { Country } from '../../classess/country/country';
import { SaleService } from '../../services/purchases/SaleService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, colors, icons, images, labels, messages, } = settings;

const currentMethod = 'Sales';

export default function Sales({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const dtSalesId = 'dtDevices';
    const isMount = useRef(true);

    const [process, setProcess] = useState({
        showLoading: false,
    });
    const [showData, setShowData] = useState(true);
    const [balanceTotals, setBalanceTotals] = useState({ documents: 0.00, others: 0.00, });

    const btnCompanies = {
        method: 'companyInformationGet',
    };
    const controls = {
        buttons: {
            details: {
                id: 'btnDetails',
            },
            companyInformation: {
                id: 'btnCompanyInformation',
            }
        },
        icons: {
            details: {
                id: 'iconDetails',
                defaultClass: icons?.fasFa?.fileInvoiceDollar,
            },
            companyInformation: {
                id: 'iconCompanyInformation',
                defaultClass: icons?.fasFa?.building,
            }
        }
    };
    //#endregion variables

    //#region methods
    //#region statement account
    const getStatementAccountDetails = async ({
        id = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getStatementAccountDetails';
        let response = getResponse({ type: 0 });
        try {
            window.location.href = `${backend?.urls?.sales}${backend?.urls?.saleUserCompanyCustomers}/${id}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: false
                });
            }
        }
    }

    const getCompanyDetails = async ({
        id = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getCompanyDetails';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let swalObj = {};
            let companyData = Company?.getClass({}, false);
            let countryData = Country?.class({}, false);
            let msgHtml = '';
            //#endregion variables

            //#region company (get data)
            msgHtml = `
            <div class='text-muted'>
                <img alt='loadingCircle' 
                    src='${settings?.gifs?.normal?.circle}' 
                    style='height:20px;width:20px;'/> ${messages?.processingPleaseWait?.[languageObj?.id]}
            </div>`;

            response = sendMessageTwo({
                msgType: 2,
                msgText: msgHtml,
                timer: 0,
                confirmButton: false,
                showProgressBar: false,
                showUrlImage: false,
                swal: null,
                update: ''
            });

            if (!response?.isSuccess || response?.isWarning) return;
            swalObj = response?.result;

            response = await SaleService.getCompanyDetailsByIdAsync({
                token: auth?.user?.token?.token,
                id: id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            companyData = !isUndNullEmp({ data: response?.result?.company, subMethod: currentMethod })?.result ?
                Company?.getClass(response?.result?.company, false) : {};
            countryData = !isUndNullEmp({ data: response?.result?.country, subMethod: currentMethod })?.result ?
                Country?.class(response?.result?.country, false) : {};
            //#endregion company (get data)

            //#region company (show data)
            //#region message set
            msgHtml = `
            <div class='text-left px-3 py-1'>
                <div class='d-flex align-items-center mb-4 border-bottom pb-3'>
                    <div class='bg-light p-2 rounded-circle mr-2 shadow-sm border'>
                        <img alt='company' 
                            src='${images?.icons?.company}' 
                            style='height:23px;width:22px;'></img>
                    </div>
                    <div>
                        <h5 class='mb-0 font-weight-bold text-dark text-uppercase' style='letter-spacing: 1px;'>${labels?.company?.[languageObj?.id]}</h5>
                        <small class='text-muted font-weight-bold'>${companyData?.name || '---'}</small>
                    </div>
                </div>
                
                <div class='row'>
                    <div class='col-md-6 mb-3'>
                        <div class='p-3 rounded bg-light border-left border-primary shadow-sm h-100'>
                            <small class='text-muted text-uppercase font-weight-bold d-block mb-1'>
                                ${labels?.rif[languageObj?.id]}
                            </small>
                            <span class='h6 mb-0 font-weight-bold'>${companyData?.rif || '---'}</span>
                        </div>
                    </div>
                     <div class='col-md-6 mb-3'>
                        <div class='p-3 rounded bg-light border-left border-info shadow-sm h-100'>
                            <small class='text-muted text-uppercase font-weight-bold d-block mb-1'>
                                ${labels?.nit[languageObj?.id]}
                            </small>
                            <span class='h6 mb-0 font-weight-bold'>${companyData?.nit || '---'}</span>
                        </div>
                    </div>
                    <div class='col-md-6 mb-3'>
                        <div class='p-3 rounded bg-light border-left border-secondary shadow-sm h-100'>
                            <small class='text-muted text-uppercase font-weight-bold d-block mb-1'>
                                ${labels?.country[languageObj?.id]}
                            </small>
                            <span class='h6 mb-0 font-weight-bold'>${countryData?.name || '---'}</span>
                        </div>
                    </div>
                    <div class='col-md-6 mb-3'>
                        <div class='p-3 rounded bg-light border-left border-success shadow-sm h-100'>
                            <small class='text-muted text-uppercase font-weight-bold d-block mb-1'>
                                ${labels?.phones[languageObj?.id]}
                            </small>
                            <span class='h6 mb-0 font-weight-bold'>${companyData?.phones || '---'}</span>
                        </div>
                    </div>
                    <div class='col-md-12 mb-3'>
                        <div class='p-3 rounded bg-light border-left border-success shadow-sm h-100'>
                            <small class='text-muted text-uppercase font-weight-bold d-block mb-1'>
                                ${labels?.address[languageObj?.id]}
                            </small>
                            <span class='h6 mb-0 font-weight-bold'>${companyData?.address || '---'}</span>
                        </div>
                    </div>
                    <div class='col-md-6 mb-3'>
                        <div class='p-3 rounded bg-light border-left border-warning shadow-sm h-100'>
                            <small class='text-muted text-uppercase font-weight-bold d-block mb-1'>
                                ${labels?.email[languageObj?.id]}
                            </small>
                            <a href='mailto:${companyData?.email}' class='text-primary font-weight-bold'>${companyData?.email || '---'}</a>
                        </div>
                    </div>
                    <div class='col-md-6 mb-3'>
                        <div class='p-3 rounded bg-light border-left border-primary shadow-sm h-100'>
                            <small class='text-muted text-uppercase font-weight-bold d-block mb-1'>
                                ${labels?.webSite[languageObj?.id]}
                            </small>
                            <a href='${companyData?.webSite}' target='_tab' rel='noreferrer' class='text-primary font-weight-bold'>${companyData?.webSite || '---'}</a>
                        </div>
                    </div>
                </div>
            </div>`;
            //#endregion message set

            //#region show message
            response = sendMessageTwo({
                msgType: 4,
                msgText: '',
                timer: 0,
                confirmButtonColor: colors?.primaryColorExp,
                confirmButton: true,
                confirmButtonText: `<i class='${icons?.fasFa?.arrowCircleLeft}'></i> ${labels?.back?.[languageObj?.id]}`,
                showProgressBar: false,
                showUrlImage: false,
                swal: swalObj,
                msgTextUpdate: msgHtml,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion show message
            //#endregion company (show data)
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: true
                });
            }
        }
    }
    //#endregion statement account

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let companiesData = [];
            let statementAccountTotalsByCompany = [];
            let balanceTotalsData = { documents: 0.00, others: 0.00, };
            //#endregion variables

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                setProcess(prev => ({ ...prev, showLoading: true }));

                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (statement account)
                response = await SaleService.getBillToPayAsync({
                    token: auth?.user?.token?.token,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                companiesData = response?.result?.companies || [];
                statementAccountTotalsByCompany = response?.result?.statementAccountTotalsByCompany || [];
                balanceTotalsData = response?.result?.balanceTotals || balanceTotalsData;
                setBalanceTotals(balanceTotalsData);
                //#endregion get data (statement account)

                //#region set datatable
                if (!isUndNullEmp({ data: statementAccountTotalsByCompany, subMethod: currentMethod })?.result &&
                    statementAccountTotalsByCompany.length > 0) {
                    response = setDataInDataTable({
                        statementAccountData: statementAccountTotalsByCompany,
                        companiesData: companiesData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));
            if (!response?.isSuccess) {
                setShowData(false);
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            $(`#${dtSalesId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.company?.[languageObj?.id], width: '55%', },
                    { title: labels?.balanceDocuments?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.balanceOthers?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtSalesId}_wrapper .col-md-6:eq(0)`);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            $(`#${dtSalesId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtSalesId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';

                    switch (methodName) {
                        case 'details':
                            getStatementAccountDetails({ id: id_, description: description, rowId: rowId, subMethod: currentMethod });
                            break;
                        case btnCompanies.method:
                            getCompanyDetails({ id: parseInt(id_), description: description, rowId: rowId, subMethod: currentMethod });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        statementAccountData = [],
        companiesData = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let statementAccountDt = [];
            //#endregion variables

            //#region process
            statementAccountData.forEach((value) => {
                // Leyends
                // sabcModel = Statement account by company model
                const sabcModel = StatementAccountByCompany.class(value, false);
                const companyModel = Company?.getClass(
                    companiesData.filter(({ secundaryId, }) => secundaryId === sabcModel.cCodEmpresa)[0] || {},
                    false
                );
                const processButtons = [
                    {
                        isVisible: true,
                        showDivider: true,
                        isEnabled: true,
                        methodName: btnCompanies.method,
                        icon: icons?.fasFa?.building,
                        label: `${labels?.companyInformationAbr[languageObj?.id]}`
                    },
                ];
                statementAccountDt.push([
                    companyModel.name,
                    setSeparatorsNumbers({ number: sabcModel.balanceDocument, withDecimals: true })?.result,
                    setSeparatorsNumbers({ number: sabcModel.balanceDeliveryNote, withDecimals: true })?.result,
                    getProcessButtons({
                        id: companyModel.id,
                        description: companyModel.name,
                        showDetails: true,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: (sabcModel.balanceDocument !== 0.00 || sabcModel.balanceDeliveryNote !== 0.00),
                        showDelete: false,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: false,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtSalesId}`)?.DataTable()?.rows?.add(statementAccountDt)?.draw(true);

            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.purchases?.billToPay} process={app?.views?.purchases?.billToPay} languageObj={languageObj} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) - Premium Bar v6.6 */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.billToPay?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0 justify-content-center justify-content-sm-end'>
                                    <li className='breadcrumb-item'><a href='/' className='text-muted'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary font-weight-bold'>{labels?.billToPay?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection
                                                alt='loadingSales'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                languageId={languageObj?.id}
                                                showText={true}
                                                width={20}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center flex-wrap justify-content-between'>
                                                    <div className='d-flex align-items-center mb-2 mb-md-0'>
                                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <img alt={labels?.purchase?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.purchse}></img>
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.billToPay?.[languageObj?.id]}</h5>
                                                            <div className='mt-1'>
                                                                <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>
                                                                    <i className={controls?.icons?.details?.defaultClass || 'fas fa-file-invoice-dollar mr-1'}></i> {labels?.purchase?.[languageObj?.id]}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-0 mt-2'>
                                                <TableIndex tableId={dtSalesId} languageObj={languageObj} />
                                            </div>

                                            <div className='card-footer bg-white border-top-0 pb-4 px-4 pt-0 mt-3'>
                                                <div className='row text-center align-items-center'>
                                                    <div className='col-md-6 d-none d-md-flex justify-content-start align-items-center'>
                                                        <div className='text-right mr-3'>
                                                            <small className='text-muted d-block'>{messages?.processCompletedSuccessfully?.[languageObj?.id]}</small>
                                                            <span className='badge badge-success px-3 shadow-sm'>{labels?.companyData?.[languageObj?.id]}</span>
                                                        </div>
                                                        <i className='fas fa-chart-line text-muted fa-2x opacity-25'></i>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3 mb-md-0'>
                                                        <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                                {labels?.balanceDocuments?.[languageObj?.id]}
                                                            </small>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>
                                                                {setSeparatorsNumbers({ number: balanceTotals.documents, withDecimals: true, })?.result}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6 col-md-3 mb-3 mb-md-0'>
                                                        <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                            <small className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                                {labels?.balanceOthers?.[languageObj?.id]}
                                                            </small>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>
                                                                {setSeparatorsNumbers({ number: balanceTotals.others, withDecimals: true, })?.result}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>
            </div>
        </div>
    )
}